<template>
  <div>
    <form class="panel-term__form panel-term__form--multi">
      <div class="panel-term__form__col"
        v-for="(term, index) in termLength"
        :key="index"
      > 
        <template v-if="activeTerms.length >= index">
          
          <template v-if="termSlots.indexOf(index) < 0 && !maxReached && validSelectionsRemaining">
            
            <div class="panel-term__optional-term">
              <h3 class="input-panel__subhead panel-term__subhead">Add another term?</h3>
              <div>
                <button class="btn btn-sm" @click.prevent="addTermSlot(index)">Yes</button>
                <button class="btn btn-sm" @click.prevent="saveTerms">No</button>
              </div>
            </div>

          </template>

          <template v-else-if="index < maxTerms ||  !validSelectionsRemaining && activeTermsIndices.indexOf(index) >= 0">
            <term-select 
              :key="term.id"
              :index="index" 
              :id="term.id"
              :value="term.value"
              @selectTerm="selectTerm"
              @deselectTerm="deselectTerm"
            ></term-select>
          </template>
        </template>

        <template v-if="isFreeOrReg && index === 1">
          <div class="panel-term__upgrade"><div><a :href="upgradeLink" @click.prevent="loadAccountView">Subscription required</a> for additional terms.</div></div>
        </template>

      </div>
    </form>
    <div class="panel-term__row panel-term__row--center" 
      v-show="maxReached || !validSelectionsRemaining"
    >
      <button class="btn btn-sm" 
        ref="submitbutton"
        :disabled="!termSet" 
        @click.prevent="saveTerms"
      >Enter</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import TermSelect from './TermSelect.vue'
import router from '../../../router'

export default {
  components: {
    'term-select' : TermSelect
  },
  data() {
    return {
      termSlots: [],
      activeTermsIndices: [],
      workspaceHasValues: true,
    }
  },
  computed: {
    utilityPlan() {
      return this.$store.getters.utilityPlan
    },
    isFreeOrReg() {
      if (this.utilityPlan.slug === 'free' || this.utilityPlan.slug === 'free-registered') {
        return true
      } 

      return false
    },
    upgradeLink() {
      switch(this.utilityPlan.slug) {
        case 'free-registered':
          return '/account/subscription'
        case 'free':
          return '/subscribe'
        break
      }
    },
    startMonth() {
      if (this.$store.getters.startMonth) {
        return moment(this.$store.getters.startMonth)
      }
    },
    termLength() {
      // The terms set in the store
      return this.$store.getters.termLength
    },
    planConfig() {
      return this.$store.getters.planConfig
    },
    maxTerms() {
      return this.planConfig.maxTerms
    },
    activeTerms() {
      let activeTerms = this.termLength
      activeTerms = activeTerms.filter(function(item) {
        return item.value != ''
      })
      return activeTerms
    },
    termLengthCount() {
      // The number of terms set in the store
      return Object.keys(this.$store.getters.termLength).length
    },
    activeTermLengthCount() {
      // The number of terms set in the store
      return Object.keys(this.activeTerms).length
    },
    nextTermId() {
      let id = 1
      
      for (let i = 0; i < this.termLengthCount; ++i) {
        if (this.termLength[i].id > id) {
          id = this.termLength[i].id
        }
      }

      return id + 1
    },
    termSet() {
      let activeTerms = this.termLength
      activeTerms = activeTerms.filter(function(item) {
        return item.value != ''
      })

      if (activeTerms.length > 0) {
        return true
      }

      return false
    },
    maxReached() {

      // Used to prevent more than the max slots from being added
      if (this.activeTerms.length < this.maxTerms) {
        return false
      } 

      return true
    },
    allowCustomTerms() {
      return this.planConfig.allowCustomTerms  
    },
    monthDiff() {
      // Used to limit available terms based on start month
      if (this.startMonth) {
        const now = moment()
        const diff = 60 - this.startMonth.diff(now, 'months')
        return diff
      }
    },
    validSelectionsRemaining() {
      if (!this.allowCustomTerms) {
        let options = [12, 24, 36]
        let selectedOptions = this.termLength.filter(term => (term.value === 12 || term.value === 24 || term.value === 36))
        
        if (selectedOptions.length) {
          for (let x = 0; x < selectedOptions.length; ++x) {
            options = options.filter(option => option != selectedOptions[x].value)
          }
        }

        options = options.filter(option => option <= this.monthDiff)

        return options.length

      } else {

        if (this.customTerms && this.customTerms.length < 1) {
          return false
        }
      }

      return true
    },
    customTerms() {
      // Generate the possible custom terms
      if (this.startMonth) {
        const diff = this.monthDiff

        let terms = []
        
        for (let i = 0; i < diff; i++) {
          terms[i] = i + 1
        } 
        
        let skip = [12,24,36],
            activeTermsArray = []

        for (let x = 0; x < this.activeTerms.length; ++x) {
          activeTermsArray.push(this.activeTerms[x].value)
        }

        skip = skip.concat(activeTermsArray)

        terms = terms.filter(function(item) {
          return skip.indexOf(item) === -1
        })

        return terms
      }
    },
  },
  methods: {
    termOridinal(index) {
      switch(index) {
        case 0:
          return '1st'
        
        case 1:
          return '2nd'

        case 2:
          return '3rd'
      }
    },
    addTermSlot(index) {
      let target = this.termSlots.indexOf(index)

      if (this.termSlots.indexOf(target) < 0) {
        this.termSlots.push(index)
      }
    },
    removeTermSlot(index) {
      let target = this.termSlots.indexOf(index)

      if (index != 0 && this.termSlots.indexOf(target) >= 0) {
        this.termSlots.splice(target)
      }
    },
    addActiveTerm(index) {
      let target = this.activeTermsIndices.indexOf(index)

      if (this.activeTermsIndices.indexOf(target) < 0) {
        this.activeTermsIndices.push(index)
      }
    },
    removeActiveTerm(index) {
      let target = this.activeTermsIndices.indexOf(index)

      if (this.activeTermsIndices.indexOf(target) >= 0) {
        this.activeTermsIndices.splice(target)
      }
    },
    saveTerms() {
      // Advance to next slide
      router.push({ name: 'FacilityProfile' })
    },
    deselectTerm(index, id) {
      this.removeActiveTerm(index)

       let obj = []

       for (let x = 0; x < this.termLengthCount; ++x) {

        // Shuffle values between terms after the one that has been cleared
        if (x < index) {
          obj[x] = {
            id: this.termLength[x].id,
            value: this.termLength[x].value
          }

        } else if (x === index) {
          obj[x] = {
            id: this.termLength[x].id,
            value: ''
          }

        } else if (x === (index + 1)) {
          obj[index] = {
            id: this.termLength[index].id,
            value: this.termLength[x].value
          }

        } else if (x === (index + 2)) {
          obj[index + 1] = {
            id: this.termLength[index + 1].id,
            value: this.termLength[x].value
          }
        }
      }

      // Add empty terms
      for (let y = 0; y < this.termLengthCount; ++y) {
        if ((y + 1) > obj.length) {
          obj[y] = {
            id: this.termLength[y].id,
            value: ''
          }
        }
      }

      // Remove empty term slots
      for (let i = 0; i < this.termSlots.length; ++i) {
        if (obj[i].value === '') {
          this.removeTermSlot(i)
        }
      }

      this.$store.dispatch('setTermLength', obj)
    },
    selectTerm(index) {
      if (!this.validSelectionsRemaining) {
        router.push({ name: 'FacilityProfile' })

        return
      }

      this.addActiveTerm(index)

      this.$nextTick(() => this.$refs.submitbutton.focus())
    },
    loadAccountView() {
      if (this.workspaceHasValues && this.utilityPlan.slug !== 'free') {
        var upgradeLink = this.upgradeLink

        var swalContent = document.createElement('div')
        swalContent.innerHTML = '<p class="alerts message alerts--no-brdr alerts--close-btn">This action will clear any unsaved changes in your workspace view, are you sure you want to leave?</p>'

        swal({
          content: swalContent,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
          cancel: {
            text: "Cancel",
            value: null,
            visible: true,
            className: "",
            closeModal: true,
          },
          confirm: {
            text: "Yes",
            value: true,
            visible: true,
            className: "",
            closeModal: true
          }
        }
        }).then((result) => {
          if (result) {
            setTimeout(function() {
              window.location.href = upgradeLink
            }, 400)
          }
        }).catch(function() {})
      } else {
        window.location.href = this.upgradeLink
      }
    }
  },
  created() {
    if (this.activeTermLengthCount > 0) {
      for (let i = 0; i < this.activeTermLengthCount; ++i) {
        this.termSlots.push(i)
        this.activeTermsIndices.push(i)
      }

    } else {
      this.termSlots.push(0)
    }
  }
}
</script>
